
import { lazy } from "react";

//lazy-loaded Layouts
const DashboardLayout = lazy(() =>
  import("layouts").then((module) => ({ default: module.DashboardLayout }))
);
const AuthLayout = lazy(() =>
  import("layouts").then((module) => ({ default: module.AuthLayout }))
);
// const ProfileLayout = lazy(() =>
//   import("layouts").then((module) => ({ default: module.ProfileLayout }))
// );

const lazyLoad = (moduleName) =>
  lazy(() =>
    new Promise((resolve) => {
      // setTimeout(() => {
      import("pages").then((module) => {
        resolve({ default: module[moduleName] });
      });
      // }, 2000);
    })
  );

const Login = lazyLoad("Login");
// const Register = lazyLoad("Register");
const Verify = lazyLoad("Verify");
const Dashboard = lazyLoad("Dashboard");
const AddRole = lazyLoad("AddRole");
// const AddUser = lazyLoad("AddUser");
const AddUserFirm = lazyLoad("AddUserFirm");
const DataTable = lazyLoad("DataTable");
// const SelectCompany = lazyLoad("SelectCompany");
const Consignor = lazyLoad("Consignor");
const Testing = lazyLoad("Testing");
const DetailsConsignor = lazyLoad("ConsignorDetails");
const MasterDetails = lazyLoad("MasterDetails");
const AddressBookDetails = lazyLoad("AddressBookDetails");
const Contact = lazyLoad("Contact");
const Unit = lazyLoad("Unit");
const Partydetail = lazyLoad("Partydetail");
const Lorryreceipt = lazyLoad("Lorryreceipt");
const Rate = lazyLoad("Rate");
const Ledger = lazyLoad("Ledger");
const Settings = lazyLoad("Settings");
const Role = lazyLoad("Role");
const User = lazyLoad("User");
const Supplier = lazyLoad("Supplier");
const Branch = lazyLoad("Branch");
const Consignee = lazyLoad("Consignee");
const Staff = lazyLoad("Staff");
const MarketDriver = lazyLoad("MarketDriver");
const OwnDriver = lazyLoad("OwnDriver");
const MarketLoad = lazyLoad("MarketLoad");
const MyBids = lazyLoad("MyBids");
const BidsRecieved = lazyLoad("BidsRecieved");
const Plan = lazyLoad("Plan");
const Invitations = lazyLoad("Invitations");
const Lr = lazyLoad("Lr");
const Trip = lazyLoad("Trip");
// const Company = lazyLoad("Company");
const ConsignorGroup = lazyLoad("ConsignorGroup");
const Material = lazyLoad("Material");
const MaterialCategory = lazyLoad("MaterialCategory");
const SupplierGroup = lazyLoad("SupplierGroup");
const VehicleGroup = lazyLoad("VehicleGroup");
const VehicleType = lazyLoad("VehicleType");
const Zone = lazyLoad("Zone");
const ChartOfAccount = lazyLoad("ChartOfAccount");
const Transactions = lazyLoad("Transactions");
const QuickUpload = lazyLoad("QuickUpload");
const ParleBill = lazyLoad("ParleBill");
const PartyAddress = lazyLoad("PartyAddress");
const FuelCardUpload = lazyLoad("FuelCardUpload");
const DriverReports = lazyLoad("DriverReports");
const TripReports = lazyLoad("TripReports");
const ProfitLossReport = lazyLoad("ProfitLossReport");
const OwnVehicleReport = lazyLoad("OwnVehicleReport");
const VehicleReports = lazyLoad("VehicleReports");
const FuelReports = lazyLoad("FuelReports");
const TripRevenueReports = lazyLoad("TripRevenueReports");
const HorizontalProfitAndLoss = lazyLoad("HorizontalProfitAndLoss");
const ProfitAndLossReport = lazyLoad("ProfitAndLossReport");
const BalanceSheet = lazyLoad("BalanceSheet")
const TripDetailsReports = lazyLoad("TripDetailsReports");
const VehicleExelProfitReport = lazyLoad("VehicleExelProfitReport");
const GeneralLedger = lazyLoad("GeneralLedger");
const JournalReport = lazyLoad("JournalReport");
const GeneralLedgerDetails = lazyLoad("GeneralLedgerDetails");
const TrialBalance = lazyLoad("TrialBalance");
const HorizontalBalanceSheet = lazyLoad("HorizontalBalanceSheet");
const EditRole = lazyLoad("EditRole");
const Vehicle = lazyLoad("Vehicle");
// const AddTrip = lazyLoad("AddTrip");
const CreatTrip = lazyLoad("CreatTrip");
const CreatTrip2 = lazyLoad("CreatTrip2");
const TripDetail = lazyLoad("TripDetail");
// const Custom = lazyLoad("Custom");
const FuelStation = lazyLoad("FuelStation");
const FuelCard = lazyLoad("FuelCard");
const FastTag = lazyLoad("FastTag");
const Vendors = lazyLoad("Vendors");
const TransactionsDetails = lazyLoad("TransactionsDetails");
const Item = lazyLoad("Item");
const AddressBook = lazyLoad("AddressBook");
// const TransactionsDetails = lazyLoad("TransactionsDetails")
const Driver = lazyLoad("Driver");
const DetailsSupplier = lazyLoad("SupplierDetails");
const DetailsUnit = lazyLoad("UnitDetails");
const DetailsDriver = lazyLoad("DriverDetails");
const DetailsConsignee = lazyLoad("ConsigneeDetails");
const DetailsVendors = lazyLoad("VendorsDetails");
const DetailsBranch = lazyLoad("BranchDetails");
const DetailsVehicle = lazyLoad("VehicleDetails");
const DetailsFuelStation = lazyLoad("FuelStationDetails");
const PaymentApproval = lazyLoad("PaymentApproval");
const Indent = lazyLoad("Indent");
const Invoicing = lazyLoad("Invoicing");
const Support = lazyLoad("Support");
const CreateBillRaise = lazyLoad("CreateBillRaise");
const BillRaiseSelectLR = lazyLoad("BillRaiseSelectLR");
const SelectClaim = lazyLoad("SelectClaim");
const ClaimSelected = lazyLoad("ClaimSelected");

const SelecedtBillRaiseLr = lazyLoad("SelecedtBillRaiseLr");
const BillSummary = lazyLoad("BillSummary");
const BillRaiseDetails = lazyLoad("BillRaiseDetails");
const ViewRole = lazyLoad("ViewRole");
const StaffDetails = lazyLoad("StaffDetails");
const TermAndPolicy = lazyLoad("TermsAndConditions");
const Policy = lazyLoad("Policy")
const FastagUpload = lazyLoad("FastagUpload");
const FleetOverview = lazyLoad("FleetOverview");
const Setting = lazyLoad("Setting");
const InvoiceDetails = lazyLoad("InvoiceDetails");
const TripExelProfitReport = lazyLoad('TripExelProfitReport');
const TripExelSummaryReport = lazyLoad('TripExelSummaryReport');
const ContractRatesUpload = lazyLoad("ContractRatesUpload");
const LRUpload = lazyLoad("LRUpload");
const LrDetailReport = lazyLoad('LrDetailReport');
const TestingUpload = lazyLoad('TestingUpload');
const Location = lazyLoad('Location');
const CompanyProfile = lazy(() => import("pages/Setting/companyProfile/CompanyProfile"));
const AllVehicleDetailReport = lazyLoad('AllVehicleDetailReport');
const Gps = lazyLoad('Gps');
const VehicleDocumentType = lazyLoad('VehicleDocumentType');
const Ebill = lazyLoad('Ebill');
const LrUploadOption = lazyLoad('LrUploadOption');
const Usabilty = lazyLoad('Usabilty');
const Wallet = lazyLoad("Wallet")

const Subscription = lazyLoad('Subscription');
const SubscriptionPlan = lazyLoad('SubscriptionPlan');
const GanPanelityUpload = lazyLoad("GanPanelityUpload");
const Fastags = lazyLoad("Fastags")
const FastagsTransaction = lazyLoad("FastagsTransaction")
const FastagDetails = lazyLoad("FastagDetails")
const Store = lazyLoad("Store")
const Inventory = lazyLoad("Inventory")
const WorkshopPurchaseParts = lazyLoad("WorkshopPurchaseParts")
const WorkshopMaster = lazyLoad("WorkshopMaster")
const WorkshopServicing = lazyLoad("WorkshopServicing")
const AddService = lazyLoad("AddService")
const SuperAdminVerify = lazyLoad('SuperAdminVerify')
const Manufacturer = lazyLoad("Manufacturer")
const Items = lazyLoad("Items")
const ChartOfAccountCategory = lazyLoad("ChartOfAccountCategory")
const SupplierSheet = lazyLoad("SupplierSheet")
const AccountingReceipt = lazyLoad("AccountingReceipt")
const AccountingPayment = lazyLoad("AccountingPayment")
const PurchaseBill = lazyLoad("PurchaseBill")
const AddEditPurchaseBill = lazyLoad("AddEditPurchaseBill");
const MainVehicleDoc = lazyLoad("MainVehicleDoc");
const ServiceReminder = lazyLoad("ServiceReminder");
const MoneyIn = lazyLoad("MoneyIn");
const MoneyOut = lazyLoad("MoneyOut");
const Firm = lazyLoad("Firm");
const AddEditFirm = lazyLoad("AddEditFirm");
const InterFirm = lazyLoad("InterFirm")
const InterFirmDetails = lazyLoad("InterFirmDetails");
const PayNowTransaction = lazyLoad("PayNowTransaction")
const TransactionExpDetails = lazyLoad("TransactionExpDetails")
const PaymentTransaction = lazyLoad("PaymentTransaction")

const FirmDetails = lazyLoad("FirmDetails");
const StatementHistoryDownload = lazyLoad("StatementHistoryDownload");
const IOCLFuelUpload = lazyLoad("IOCLFuelUpload")
const vehiclePlanning = lazyLoad("vehiclePlanning")
const AddPaymentReceipt = lazyLoad("AddPaymentReceipt")

// creating route objects
const createRoute = (path, element, isPrivate = false, termsAndCondition = false, policy = false, superAdminVerify = false, supplierSheet = false) => ({
  path,
  element,
  isPrivate,
  termsAndCondition,
  policy,
  superAdminVerify,
  supplierSheet
});

export const routeConfigs = [
  {
    layout: AuthLayout,
    children: [
      createRoute("/", Login, false),
      createRoute("other", Login, false),
      createRoute("verify", Verify, false),
      createRoute("term_policy", TermAndPolicy, false, true),
      createRoute("policy", Policy, false, false, true),
      createRoute("sverify/:id", SuperAdminVerify, false, false, false, true),
      // createRoute("template", SupplierSheet, false,false,false,false,true),
      createRoute("7346756734545645646", SupplierSheet, false, false, false, false, true),
    ],
  },
  {
    layout: DashboardLayout,
    children: [
      createRoute("dashboard", Dashboard, true),
      createRoute("setting", Setting, true),
      createRoute("setting/role/addrole", AddRole, true),
      // createRoute("setting/user/adduser", AddUser, true),
      createRoute("setting/user/adduser", AddUserFirm, true),
      createRoute("datatable", DataTable, true),
      createRoute("language", Verify, true),
      createRoute("testing", Testing, true),
      createRoute("details/contact/:id", Contact, true),
      createRoute("details/units/:id", Unit, true),
      createRoute("details/partydetail/:id", Partydetail, true),
      createRoute("details/ledger/:id", Ledger, true),
      createRoute("details/rate/:id", Rate, true),
      createRoute("details/settings/:id", Settings, true),
      createRoute("setting/role", Role, true),
      createRoute("setting/role/edit/:id", EditRole, true),
      createRoute("setting/user", User, true),
      createRoute("details/lr/:id", Lorryreceipt, true),
      createRoute("account/supplier", Supplier, true),
      createRoute("account/branch", Branch, true),
      createRoute("account/consignor", Consignor, true),
      createRoute("accounting/staff", Staff, true),
      createRoute("account/unit", Unit, true),
      createRoute("account/consignee", Consignee, true),
      createRoute("account/vehicle", Vehicle, true),
      createRoute("account/marketdriver", MarketDriver, true),
      createRoute("account/owndriver", OwnDriver, true),
      createRoute("account/driver", Driver, true),
      createRoute("account/fuel_station", FuelStation, true),
      createRoute("/fuelcard", FuelCard, true),
      createRoute("/fasttag", FastTag, true),
      createRoute("account/vendors", Vendors, true),
      createRoute("market_load", MarketLoad, true),
      createRoute("my_bids", MyBids, true),
      createRoute("bids_received", BidsRecieved, true),
      createRoute("plan/planlist", Plan, true),
      createRoute("invitations", Invitations, true),
      createRoute("trip/addtrip", Trip, true),
      createRoute("trip/addtrip/createtrip", CreatTrip, true),
      createRoute("trip/addtrip/createtrip2", CreatTrip2, true),
      createRoute("trip/addtrip/dispatched/:id", TripDetail, true),
      createRoute("lr/addlr", Lr, true),
      createRoute("setting/company", CompanyProfile, true),
      createRoute("setting/ConsignorGroup", ConsignorGroup, true),
      createRoute("setting/material", Material, true),
      createRoute("setting/material_category", MaterialCategory, true),
      createRoute("setting/supplier_group", SupplierGroup, true),
      createRoute("setting/vehicle_group", VehicleGroup, true),
      createRoute("setting/vehicle_type", VehicleType, true),
      createRoute("setting/zone", Zone, true),
      createRoute("accounting/transactions", Transactions, true),
      createRoute("accounting/chart_of_account", ChartOfAccount, true),
      createRoute("quick_uploads", QuickUpload, true),
      createRoute("quick_uploads/parle_bill", ParleBill, true),
      createRoute("quick_uploads/party_address", PartyAddress, true),
      createRoute("reports/driver_reports", DriverReports, true),
      createRoute("report", TripReports, true),
      createRoute("report/profit_loss_report", ProfitLossReport, true),
      createRoute("report/own_vehicle_report", OwnVehicleReport, true),
      createRoute("reports/vehicle_reports", VehicleReports, true),
      createRoute("reports/fuel_reports", FuelReports, true),
      createRoute(
        "accounting/transactions/bank_transaction_list",
        TransactionsDetails,
        true
      ),
      createRoute("/address_book/details/:id", MasterDetails, true), // AddressBookDetails
      createRoute("account/consignor/details/:id", MasterDetails, true), // DetailsConsignor
      createRoute("account/supplier/details/:id", MasterDetails, true), // DetailsSupplier
      createRoute("accounting/staff/details/:id", MasterDetails, true), // StaffDetails
      createRoute("account/unit/details/:id", MasterDetails, true), // DetailsUnit
      createRoute("account/driver/details/:id", MasterDetails, true), // DetailsDriver
      createRoute("account/consignee/details/:id", MasterDetails, true), // DetailsConsignee
      createRoute("account/vendors/details/:id", MasterDetails, true), // DetailsVendors
      createRoute("account/branch/details/:id", MasterDetails, true), // DetailsBranch
      createRoute("account/vehicle/details/:id", MasterDetails, true), // DetailsVehicle
      createRoute("account/fuel_station/details/:id", MasterDetails, true), // DetailsFuelStation
      createRoute("payment_approval", PaymentApproval, true),
      createRoute("indent", Indent, true),
      createRoute("/invoicing", Invoicing, true),
      createRoute("invoicing/createbillraise", CreateBillRaise, true),
      createRoute("masters/item", Item, true),
      createRoute("address_book", AddressBook, true),
      createRoute("invoicing/selectlr", BillRaiseSelectLR, true),
      createRoute("invoicing/selectedlr", SelecedtBillRaiseLr, true),
      createRoute("invoicing/summary", BillSummary, true),
      createRoute("invoicing/details/:id", BillRaiseDetails, true), //  BillRaiseInvoiceDetails
      createRoute("/support", Support, true),
      // createRoute("setting/user/adduser/:id", AddUser, true),
      createRoute("setting/user/adduser/:id", AddUserFirm, true),

      createRoute("setting/role/view/:id", ViewRole, true),
      createRoute("quick_uploads/fuel_card", FuelCardUpload, true),
      createRoute("quick_uploads/fastag", FastagUpload, true),
      createRoute("quick_uploads/contract_rates_uplaod", ContractRatesUpload, true),
      createRoute("report/trip_detail_report", TripDetailsReports, true),
      createRoute("report/trip_revenue_report", TripRevenueReports, true),
      createRoute("report/horizontal_profit_loss", HorizontalProfitAndLoss, true),
      createRoute("report/profit_and_loss_report", ProfitAndLossReport, true),
      createRoute("report/balance_sheet", BalanceSheet, true),
      createRoute("report/general_ledger", GeneralLedger, true),
      createRoute("report/journal_report", JournalReport, true),
      createRoute("report/general_ledger/general_ledger_details/:id", GeneralLedgerDetails, true),
      createRoute("report/trial_balance", TrialBalance, true),
      createRoute("report/horizontal_balance_sheet", HorizontalBalanceSheet, true),
      createRoute("fleet_overview", FleetOverview, true),
      createRoute("report/vehicle_profit_report", VehicleExelProfitReport, true),
      createRoute("invoicing/select_claims", SelectClaim, true),
      createRoute("invoicing/selected_claims", ClaimSelected, true),
      createRoute("invoicing/details/:id/:type", InvoiceDetails, true),
      createRoute("report/trip_profit_report", TripExelProfitReport, true),
      createRoute("report/trip_report_summary", TripExelSummaryReport, true),
      createRoute("quick_uploads/lr_uplaod", LRUpload, true),
      createRoute("report/lr_detail_report", LrDetailReport, true),
      createRoute("quick_uploads/test", TestingUpload, true),
      createRoute("setting/location", Location, true),
      createRoute('report/vehicled', AllVehicleDetailReport, true),
      createRoute('setting/gpsintegration', Gps, true),
      createRoute('setting/vehicledoc', VehicleDocumentType, true),
      createRoute('ebill', Ebill, true),
      createRoute("quick_uploads/lr_uplaod_option", LrUploadOption, true),
      createRoute("usability", Usabilty, true),
      createRoute("wallet", Wallet, true),
      createRoute("subscription", Subscription, true),
      createRoute("subscription/plan_detail", SubscriptionPlan, true),
      createRoute("quick_uploads/gan_panelity", GanPanelityUpload, true),
      createRoute("quick_uploads/iocl_fuel", IOCLFuelUpload, true),

      
      createRoute("fastag", Fastags, true),
      createRoute("fastagtxn", FastagsTransaction, true),
      createRoute("fastag_details/:id", FastagDetails, true),

      // work shop module
      createRoute("WorkshopStore", Store, true),
      createRoute("WorkshopManageInventory", Inventory, true),
      createRoute("WorkshopPurchaseParts", WorkshopPurchaseParts, true),
      createRoute("WorkshopMaster", WorkshopMaster, true),
      createRoute("WorkshopServicing", WorkshopServicing, true),
      createRoute("WorkshopServicing/AddService", AddService, true),
      createRoute("WorkshopManufacturer", Manufacturer, true),
      createRoute("WorkshopItems", Items, true),
      createRoute("accounting/chartofaccounts", ChartOfAccountCategory, true),
      // createRoute("7346756734545645646",SupplierSheet,true),
      createRoute("accounting/receipt", AccountingReceipt, true),
      createRoute("accounting/payments", AccountingPayment, true),
      createRoute("PurchaseBill", PurchaseBill, true),
      createRoute("PurchaseBill/addBill", AddEditPurchaseBill, true),
      createRoute("account/vdocuments", MainVehicleDoc, true),
      createRoute("account/vservicereminder", ServiceReminder, true),
      createRoute("accounting/moneyout", MoneyOut, true),
      createRoute("accounting/moneyin", MoneyIn, true),

      // settings section
      createRoute("setting/firm", Firm, true),
      createRoute("setting/firm/add", AddEditFirm, true),
      createRoute("accounting/interfirm", InterFirm, true),
      createRoute("accounting/interfirm/details/:id", InterFirmDetails, true),
      createRoute("accounting/transactions/paynow_transaction", PayNowTransaction, true),
      createRoute("setting/firm/details/:id", FirmDetails, true),
      createRoute("paynow-downloads", StatementHistoryDownload, true),
      createRoute("accounting/ptransactions/:id", TransactionExpDetails, true),
      createRoute("accounting/ptransactions", PaymentTransaction, true),
      createRoute("accounting/general_expense", TransactionExpDetails, true),
      createRoute("account/fleet-planning", vehiclePlanning, true),
      createRoute("accounting/add_payment_receipt", AddPaymentReceipt, true),

    ],
  },
  // {
  //   layout: ProfileLayout,
  //   children: [
  //     createRoute('register', Register, true),
  //     createRoute('profile', SelectCompany, true),
  //     createRoute('custom-table', Custom, true),
  //   ],
  // },
];
